export interface Contact {
    contact: number;
    address: string;
    address2: string;
    email: string;
    company: string;
    fax: number;
    workingTime: string;
    phone: number;
    phone2: number;
    phoneSpareParts: number;
}

export class ContactHelper {

    static transformFromAPI(apiObject: Object): Contact {
        return {
            contact: apiObject['CO_CONTACTO'],
            address: apiObject['CO_DIRECCION'],
            address2: apiObject['CO_DIRECCIONPARTE2'], 
            email: apiObject['CO_EMAIL'],
            company: apiObject['CO_EMPRESA'],
            fax: apiObject['CO_FAX'],
            workingTime: apiObject['CO_HORARIO'],
            phone: apiObject['CO_TELEFONO'],
            phone2: apiObject['CO_TELEFONO2'],
            phoneSpareParts: apiObject['CO_TELEFONORECAMBIOS'],
        };
    }
}
